import { Component, OnInit, OnDestroy, AfterViewInit, Inject } from "@angular/core";
import { GoogleAuthService } from "@/angular-blocworx/components/login-with-google/google-auth.service";
import { Subscription } from "rxjs";
import { filter, take } from "rxjs/operators";

declare const google: any;

@Component({
    selector: "login-with-google",
    templateUrl: "angular-blocworx/components/login-with-google/login-with-google.html",
    styleUrls: ["angular-blocworx/components/login-with-google/login-with-google.scss"],
})
export class LoginWithGoogleComponent implements OnInit, OnDestroy, AfterViewInit {
    isLoggedIn: boolean = false;
    userName: string | null = null;
    userEmail: string | null = null;
    userImageUrl: string | null = null;

    private authSubscription: Subscription = new Subscription();

    constructor(@Inject(GoogleAuthService) private googleAuthService: GoogleAuthService) {}

    ngOnInit(): void {
        this.authSubscription.add(
            this.googleAuthService.isLoggedIn$.subscribe((loggedIn) => {
                this.isLoggedIn = loggedIn;
            })
        );
        this.authSubscription.add(
            this.googleAuthService.user$.subscribe((user) => {
                if (user) {
                    this.userName = user.name;
                    this.userEmail = user.email;
                    this.userImageUrl = user.imageUrl;
                } else {
                    this.userName = null;
                    this.userEmail = null;
                    this.userImageUrl = null;
                }
            })
        );
    }

    ngAfterViewInit(): void {
        this.authSubscription.add(
            this.googleAuthService.isGoogleAuthInitialized$
                .pipe(
                    filter((isInitialized) => isInitialized === true),
                    take(1)
                )
                .subscribe(() => {
                    // Now that GIS is initialized, safely render the Google Sign-In button.
                    if (typeof google !== "undefined" && google.accounts && google.accounts.id) {
                        const buttonContainer = document.getElementById("google-login-button"); // Ensure this ID matches your HTML
                        if (buttonContainer) {
                            google.accounts.id.renderButton(buttonContainer, {
                                theme: "outline",
                                size: "large",
                                text: "signin_with", // or "continue_with"
                                shape: "rectangular",
                                width: "250", // You can set width
                            });
                        }
                    }
                })
        );
    }

    signOutFromGoogle(): void {
        this.googleAuthService.signOut();
    }

    ngOnDestroy(): void {
        this.authSubscription.unsubscribe();
    }
}
